import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {IncidentServices} from '../../shared/services/src/api/incident.services';
import {TranslateService} from '@ngx-translate/core';
import * as _ from 'lodash';
import {StringUtils} from '../../shared/utils';

@Component({
    selector: 'responders-popup',
    templateUrl: './responder.popup.html',
    styleUrls: [
        '../table/table.component.scss',
        '../table/table-extra-style-for-opsnow.component.scss'    //  opsnow용도의 테이블 스타일을 파일 단위로 분리해서 추가함.
    ]
})
export class ResponderPopupComponent implements OnInit, OnChanges {
    @Input() public selectedData: any;

    public dataLoading = true;

    private tckNo = 0;
    private tcktActvHistNo = 0;
    private calcStepOrdrNo = 0;
    private escalPlcyNm = '';
    private regDt: any;

    private companyId = '';

    /** 테이블에 파싱될 데이터 **/
    public receiversTableData: any;
    private rawTableData: any;

    /** 검색결과 카운트표현 변수 **/
    private addInfo: any;
    private sucsCount = 0;
    private failCount = 0;
    private etcCount = 0;
    public sucsCnt = '0';
    public failCnt = '0';
    public etcCnt = '0';

    private strTime: any;
    private strLeftTitle: any;


    public rows: Array<any> = [];
    public columns: Array<any> = [
        {title: 'MK.00298', name: 'no',         className: 'no align center td-center',                                 sort: false},
        {title: 'MK.00158', name: 'userNm',     className: 'title align center',          code: 'userNo',     sort: false},
        {title: 'MK.00159', name: 'notiLog',    className: 'title align center',          code: 'notiLog',    sort: false},
        {title: 'MK.00160', name: 'sendDt',     className: 'date align center td-center',                               sort: false},
        {title: 'MK.00161', name: 'sendRsltNm', className: 'statusClassTxt align center', code: 'sendRsltNm', sort: false}
    ];

    public config: any = {
        tableID: 'escalationPolicyResponderList',
        tableTitle: 'captionTest',
        checkBox: false,
        paging: true,
        sorting: {columns: this.columns},
        colGroup: true,
        className: ['info incident popup']
    };

    public totalCount = 0;
    public totalCnt = '0';

    constructor(private _incidentServices: IncidentServices,
                private translate: TranslateService) {
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        const chng = changes['selectedData'];

        if (chng !== undefined) {
            try {
                this.paramInit();
                const params = {};

                this.selectedData.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
                    params[key] = value;
                });

                this.tckNo = params['tckNo'];
                this.tcktActvHistNo = params['tcktActvHistNo'];
                this.calcStepOrdrNo = params['calcStepOrdrNo'];
                this.escalPlcyNm = params['escalPlcyNm'];
                this.companyId = params['companyId']; //curCmpnId

                this.Apply();
            } catch (e) {
            }

        }
    }

    private paramInit() {
        this.tckNo = 0;
        this.tcktActvHistNo = 0;
        this.calcStepOrdrNo = 0;
        this.escalPlcyNm = '';
        this.regDt = '';

        this.companyId = '';

        /** 테이블에 파싱될 데이터 **/
        this.receiversTableData = [];
        this.rawTableData = [];

        /** 검색결과 카운트표현 변수 **/
        this.addInfo = '';
        this.sucsCount = 0;
        this.failCount = 0;
        this.etcCount = 0;
        this.sucsCnt = StringUtils.numberWithCommas(this.sucsCount);
        this.failCnt = StringUtils.numberWithCommas(this.failCount);
        this.etcCnt = StringUtils.numberWithCommas(this.etcCount);

        this.strTime = '';
        this.strLeftTitle = '';

        this.rows = [];
    }

    private Apply(): any {
        if (this.tckNo === 0 || this.tcktActvHistNo === 0 ||  this.companyId === '') {
            return;
        }

        this.dataLoading = false;
        let endPoint = '';

        this._incidentServices.getEscalationPolicyResponders(this.tckNo, this.tcktActvHistNo, this.companyId)
            .then(result => {
                if (result.status === 200) {
                    this.rawTableData = result.json().data;
                    //console.log(this.rawTableData);
                    this.receiversTableData = result.json().data.receivers;
                    this.regDt = moment(this.rawTableData.regDt).format('YYYY-MM-DD HH:mm');

                    let idx = 0;

                    if (this.receiversTableData === undefined) {
                        this.dataLoading = true;
                        return;
                    }
                    // 사용자 이름, 알림 타입 (보이스콜 > SMS > 이메일) 순으로 정렬
                    this.receiversTableData = _.orderBy(this.receiversTableData, ['userNm', 'receiver.userCntcTypeCd'], ['asc', 'desc']);
                    this.receiversTableData.forEach(table => {
                        idx++;
                        table.sendDt = this.rawTableData.sendDt;
                        table.no = idx;
                        table.statusClassTxt = (table.receiver.postResult === 'SEND_SUCCESS') ? 'receive' : 'fail';

                        let userCntcTypeCd = '';
                        switch (table.receiver.userCntcTypeCd) {
                            case 'EMAIL':
                                //endPoint = StringUtils.maskingEmail(table.receiver.email);
                                endPoint = table.receiver.email;
                                userCntcTypeCd = this.translate.instant('CD.UCTC010');
                                break;
                            case 'MOBILE':
                                //endPoint = `${table.receiver.rcvrNotiAddrVal !== undefined ? StringUtils.maskingPhoneNo(table.receiver.rcvrNotiAddrVal) : StringUtils.maskingPhoneNo(table.receiver.mobileNo)}`;
                                endPoint = table.receiver.rcvrNotiAddrVal;
                                userCntcTypeCd = this.translate.instant('CD.UCTC020');
                                break;
                            case 'PHONE':
                                //endPoint = `${table.receiver.rcvrNotiAddrVal !== undefined ? StringUtils.maskingPhoneNo(table.receiver.rcvrNotiAddrVal) : StringUtils.maskingPhoneNo(table.receiver.phoneNo)}`;
                                endPoint = table.receiver.rcvrNotiAddrVal;
                                userCntcTypeCd = this.translate.instant('CD.UCTC030');
                                //table.sendRsltNm = table.sendRsltCd;
                                break;
                            case 'SLACK':
                                endPoint = `${table.receiver.extensionAccountInfo.teamDomain}.slack.com → ${table.receiver.extensionAccountInfo.channelName}`;
                                userCntcTypeCd = this.translate.instant('CD.UCTC040');
                                break;
                            case 'PUSH':
                                endPoint = table.receiver.pushAccountInfo.deviceName;
                                userCntcTypeCd = this.translate.instant('CD.UCTC060');
                                break;
                            case 'KAKAO':
                                //endPoint = `${table.receiver.rcvrNotiAddrVal !== undefined ? StringUtils.maskingPhoneNo(table.receiver.rcvrNotiAddrVal) : StringUtils.maskingPhoneNo(table.receiver.kakaoNo)}`;
                                endPoint = table.receiver.rcvrNotiAddrVal;
                                userCntcTypeCd = this.translate.instant('CD.UCTC070');
                                break;
                            case 'TELEGRAM':
                                endPoint = table.receiver.telegramChatToken;
                                userCntcTypeCd = this.translate.instant('CD.UCTC080');
                                break;
                            case 'LINE':
                                endPoint = table.receiver.lineUserId;
                                userCntcTypeCd = this.translate.instant('CD.UCTC090');
                                break;
                        }

                        //sendRsltCd는 server단의 enum타입이라 임의로 수정이 불가능함
                        //이에따라 sendResultCd라는 코드를 생성하여 사용하기로함
                        //다국어는sendResultCd별로 등록하여 사용
                        table.sendRsltNm = this.translate.instant(`CD.${table.sendResultCd}`);

                        // Extension 전송 결과 코드가 세분화 및 결정되면 리팩토링 필요
                        let rcvrNotiAddrVal: any;
                        switch (table.receiver.postResult) {
                            case 'NO_NOTI_RULE':
                                table.sendRsltNm = this.translate.instant('MK.00958');
                                table.notiLog = this.translate.instant('MK.00957');
                                break;
                            case 'NO_NOTI_RULE_CONDITION':
                                table.notiLog = this.translate.instant('MK.01217', {
                                    contactType: userCntcTypeCd,
                                    contact: endPoint
                                });
                                table.notiLog = table.notiLog + '<br>' + this.translate.instant('MK.01127');
                                break;
                            case 'NOTI_FORWARDED':
                                table.sendRsltNm = this.translate.instant('CD.PSTRS1103');
                                rcvrNotiAddrVal = JSON.parse(table.receiver.rcvrNotiAddrVal);
                                table.notiLog = this.translate.instant('MK.01675', {
                                    userNm: rcvrNotiAddrVal.fwdgUserNm
                                });
                                break;
                            case 'NOTI_FORWARDED_NO_ROLE':
                                table.sendRsltNm = this.translate.instant('CD.PSTRS1104');
                                rcvrNotiAddrVal = JSON.parse(table.receiver.rcvrNotiAddrVal);
                                table.notiLog = this.translate.instant('MK.01677', {
                                    userNm: rcvrNotiAddrVal.fwdgUserNm
                                });
                                break;
                            case 'IGNORED_BY_NOTI_LIMIT':
                                table.notiLog = this.translate.instant('MK.01217', {
                                    contactType: userCntcTypeCd,
                                    contact: endPoint
                                });
                                table.notiLog = table.notiLog + '<br>' + this.translate.instant('MK.01739');
                                break;
                            case 'IGNORED_BY_NOTI_MUTE':
                                table.notiLog = this.translate.instant('MK.01217', {
                                    contactType: userCntcTypeCd,
                                    contact: endPoint
                                });
                                table.notiLog = table.notiLog + '<br>' + this.translate.instant('MK.01740');
                                break;
                            default:
                                if (table.receiver.userCntcTypeCd === 'PHONE') {
                                    table.notiLog = this.translate.instant('MK.01337', {
                                        contactType: userCntcTypeCd,
                                        contact: endPoint
                                    });
                                } else {
                                    table.notiLog = this.translate.instant('MK.00162', {
                                        contactType: userCntcTypeCd,
                                        contact: endPoint
                                    });
                                }
                                break;
                        }

                        if (table.errNotiRcvr) {
                            table.errNotiRcvr.receiver.email = StringUtils.maskingEmail(table.errNotiRcvr.receiver.email);
                        }
                    });

                    this.setRows(this.receiversTableData);

                    this.addInfo = result.json().addInfo;
                    this.totalCount = this.addInfo.total;
                    this.totalCnt = StringUtils.numberWithCommas(this.totalCount);

                    // IA 정책 결정되면 리팩토링
                    this.sucsCount = this.addInfo.notiCount.skipCnt + this.addInfo.notiCount.sucsCnt;
                    this.failCount = this.addInfo.notiCount.failCnt;
                    this.etcCount = this.addInfo.notiCount.noNotiCnt;
                    this.sucsCnt = StringUtils.numberWithCommas(this.sucsCount);
                    this.failCnt = StringUtils.numberWithCommas(this.failCount);
                    this.etcCnt = StringUtils.numberWithCommas(this.etcCount);

                    this.strTime = (this.calcStepOrdrNo === undefined) ? '' : `${this.escalPlcyNm} step${this.calcStepOrdrNo}`;
                    this.strLeftTitle = (this.calcStepOrdrNo === undefined) ? this.translate.instant('MK.00727') : this.translate.instant('MK.00081');
                    this.strLeftTitle += this.translate.instant('MK.00728');

                    //console.log(this.receiversTableData);
                }
            });
    }

    /** 테이블에 데이터 셋팅 **/
    public setRows(data): any {
        this.rows =  data;
        this.dataLoading = true;
    }

    toggleFold(event) {
        const $target = $(event.target);
        $target.toggleClass('fold');
        $target.closest('tr').toggleClass('fold');
    }

    close() {
        $.magnificPopup.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/activity-history/responder.popup.ts